import React from 'react';
import {
    Box
  } from '@mui/material';

export default function BoxIndicateurCourse(cell: string, trueValue: string, falseValue: string, labelTrue: string, labelFalse: string) {
    return (
    <Box
    component="span"
    sx={(theme) => ({
      backgroundColor:
        cell==trueValue
        ? theme.palette.success.dark
        : theme.palette.error.dark,
      borderRadius: '0.25rem',
      color: '#fff',
      maxWidth: '9ch',
      p: '0.25rem',
      display: cell==trueValue?'flex':'none'
    })}
  >        
    {cell==trueValue?labelTrue:labelFalse}
    </Box>
)   
};